module.exports = __webpack_public_path__ + "static/img/yujiaokuanjiaona.f002abad.png";